/**
 * API Logs endpoint filter options.
 * Most options are gated by tenant role permissions (plan-scoped via userRole).
 * Integration-gated options use requiredIntegrationCodes against login
 * userIntegrations (plan catalogue codes, e.g. salasa, tap, al-rajhi-bank).
 * Empty value = All (always shown).
 *
 * Wallet endpoints: show if tenant has any wallet-related access
 * (wallet coupons, customer wallet history, or wallet reports).
 */
export const API_LOG_ENDPOINT_OPTIONS = [
  { labelKey: "All", value: "" },
  {
    labelKey: "Place Order",
    value: "/checkout/api/v1/orders/placeOrder",
    requiredPermissions: [{ categoryId: 9, permissionId: "order_1" }],
  },
  {
    labelKey: "Capture Payment",
    value: "/checkout/api/v1/orders/capturePayment",
    requiredPermissions: [{ categoryId: 9, permissionId: "order_1" }],
  },
  {
    labelKey: "Coupon Apply",
    value: "/checkout/api/v1/coupons/apply",
    requiredPermissions: [{ categoryId: 14, permissionId: "promotion_1" }],
  },
  {
    labelKey: "Verify Mokafaa OTP",
    value: "/checkout/api/v1/orders/verifyAlrajhiOTP",
    // Payments → Mokafaa Points (catalogue code: al-rajhi-bank)
    requiredIntegrationCodes: ["al-rajhi-bank"],
  },
  {
    labelKey: "Pay With Mokafaa",
    value: "/checkout/api/v1/orders/payWithAlrajhi",
    requiredIntegrationCodes: ["al-rajhi-bank"],
  },
  {
    labelKey: "Redeem Loyalty Points",
    value: "/checkout/api/v1/loyalty-points/redeem",
    requiredPermissions: [{ categoryId: 20, permissionId: "loyalty_1" }],
  },
  {
    labelKey: "Create Tap Charge",
    value: "/checkout/api/v1/orders/createTapCharge",
    // Payments → Tap
    requiredIntegrationCodes: ["tap"],
  },
  {
    labelKey: "Verify Tap Payment",
    value: "/checkout/api/v1/orders/verifyTapPayment",
    requiredIntegrationCodes: ["tap"],
  },
  {
    labelKey: "Create Tap Charge External",
    value: "https://api.tap.company/v2/charges",
    requiredIntegrationCodes: ["tap"],
  },
  {
    labelKey: "Add New Card",
    value: "/checkout/api/v1/saved-card/addNewCard",
    requiredPermissions: [{ categoryId: 9, permissionId: "order_1" }],
  },
  {
    labelKey: "Send Credit",
    value: "/checkout/api/v1/wallet/sendCredit",
    requiredPermissions: [
      { categoryId: 46, permissionId: "coupon_redeem_1" },
      {
        categoryId: 7,
        permissionId: "customersPermission_1",
        subPermissionId: "view_wallet_history",
      },
      {
        categoryId: 16,
        permissionId: "report_1",
        subPermissionId: "view_wallet_reports",
      },
    ],
  },
  {
    labelKey: "Wallet Recharge",
    value: "/checkout/api/v1/wallet/recharge",
    requiredPermissions: [
      { categoryId: 46, permissionId: "coupon_redeem_1" },
      {
        categoryId: 7,
        permissionId: "customersPermission_1",
        subPermissionId: "view_wallet_history",
      },
      {
        categoryId: 16,
        permissionId: "report_1",
        subPermissionId: "view_wallet_reports",
      },
    ],
  },
  {
    labelKey: "Booking",
    value: "/support-tickets/api/v1/page/booking",
    requiredPermissions: [{ categoryId: 21, permissionId: "booking_1" }],
  },
  {
    labelKey: "Generate Apple Token",
    value: "/checkout/api/v1/orders/generateAppleToken",
    // Apple Pay token flow uses Tap
    requiredIntegrationCodes: ["tap"],
  },
  {
    labelKey: "Place Salasa Order",
    value: "/checkout/api/v1/orders/placeSalasaOrder",
    // E-Store → Salasa on the tenant plan
    requiredIntegrationCodes: ["salasa"],
  },
  {
    labelKey: "Create Salasa Order",
    value: "https://integration.salasa.co/api/v1/orders",
    requiredIntegrationCodes: ["salasa"],
  },
]

export default API_LOG_ENDPOINT_OPTIONS
